module.exports = __webpack_public_path__ + "img/8.88.f917dc31.png";